import React from "react";

import { makeStyles } from "@material-ui/core/styles";

import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";

import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
//import { Link } from "react-router-dom";

//import styles from "assets/jss/material-dashboard-pro-react/views/dashboardStyle.js";

import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";

//import imagine2 from "assets/img/sidebar-2.jpg";

import PropTypes from "prop-types";

import welcomeImage from "assets/img/sidebar-2.jpg";

const delay = 5;

const stylesBackground = {
  background: {
    background: "url(" + welcomeImage + ")",
    border: "2px solid black",
    backgroundSize: "cover",
  },
};

const stylesTransbox = {
  transbox: {
    margin: "30px",
    backgroundColor: "#ffffff",
    border: "1px solid black",
    opacity: "0.6",
  },
};

const stylesText = {
  text: {
    margin: "5%",
    fontWeight: "bold",
    color: "#000000",
    textAlign: "center",
  },
};

const useStylesBackground = makeStyles(stylesBackground);
const useStylesTransbox = makeStyles(stylesTransbox);
const useStylesText = makeStyles(stylesText);

export default function Dashboard(props) {
  const [show, setShow] = React.useState(false);

  const classesBackground = useStylesBackground();
  const classesTransbox = useStylesTransbox();
  const classesText = useStylesText();

  const classes = { ...classesBackground, ...classesTransbox, ...classesText };

  React.useEffect(() => {
    let timer1 = setTimeout(() => setShow(true), delay * 1000);
    return () => {
      clearTimeout(timer1);
    };
  }, []);

  const projectsDb = props.projects;
  const studiesDb = props.studies;

  let projectPubs = [];
  projectsDb.map((project) => {
    project.pmids &&
      project.pmids.map((pmid) => {
        projectPubs.push(pmid);
      });
  });

  // const projectStudies = studiesDb.filter((study) => {   ### got rid of this part because now all studies entered here should be relevant either as projects or individual
  //   return projectPubs.includes(study.uid);
  // });

  const allStudies = studiesDb.map((study) => {
    const withDate = { ...study, date: new Date(study.date) };

    return withDate;
  });

  const arrangedStudies = allStudies.sort((a, b) => b.date - a.date);

  const studies = arrangedStudies.slice(0, 10);

  const currentYear = new Date().getFullYear();

  const isCurrentYear = function (year) {
    return year.includes(currentYear);
  };

  const dateArrays = studiesDb.map((study) => {
    return study.date;
  });

  const publicationsCurrentYear = dateArrays.filter(isCurrentYear).length;

  return show ? (
    <div>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12} lg={12}>
          <Card>
            <div className={classes.background}>
              <Carousel
                autoPlay={true}
                stopOnHover={false}
                infiniteLoop={true}
                interval={8000}
              >
                {studies.map((study) => {
                  //const descriptionPreEdit = String(study.description);

                  const authors = String(study.authors);

                  const date = study.date;

                  //const day = ("0" + date.getDate()).slice(-2);
                  const month = ("0" + (date.getMonth() + 1)).slice(-2);
                  const year = date.getFullYear();

                  const dateFormatted = month + "/" + year;

                  const link = "https://pubmed.ncbi.nlm.nih.gov/" + study.uid;

                  //const description = descriptionPreEdit.replaceAll("\n", "<br>");

                  return (
                    <div key={study.id}>
                      <div className={classes.transbox}>
                        <h1 className={classes.text}> {study.title}</h1>
                        {/* <div
                      dangerouslySetInnerHTML={{
                        __html: description,
                      }}
                    /> */}
                        <h3 className={classes.text}>{dateFormatted}</h3>
                        <h4 className={classes.text}>{authors}</h4>

                        <h3 className={classes.text}>
                          <a
                            href={link}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {link}
                          </a>
                        </h3>
                      </div>
                    </div>
                  );
                })}
              </Carousel>
              {publicationsCurrentYear > 0 && (
                <div className={classes.transbox}>
                  <h2 className={classes.text}>
                    {" "}
                    {publicationsCurrentYear + " publications this year!"}
                  </h2>
                </div>
              )}
            </div>
          </Card>
        </GridItem>
      </GridContainer>
    </div>
  ) : (
    <div>
      {" "}
      <GridContainer>
        <GridItem xs={12} sm={12} md={12} lg={12}>
          <Card className={classes.background}>
            <CardBody>
              <div className={classes.transbox}>
                <h1 className={classes.text}>
                  Welcome to the PREVENT (Pediatric REspiratory and VENTilation)
                  Group!
                </h1>
                {/* <h3 className={classes.text}>
                  <Link to="/portal/conferences">
                    Click Here to Register for the Pediatric ARDS and Ventilator
                    Liberation Symposium!
                  </Link>
                </h3> */}

                <h3 className={classes.text}>
                  Please wait to see a selection of recent publications from our
                  PREVENT Group
                </h3>
              </div>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    </div>
  );
}

Dashboard.propTypes = {
  studies: PropTypes.array,
  projects: PropTypes.array,
};


